<template>
    <div class="header" :style="{'width': width + 'px'}">
        <div class="menu">
            <div class="logo" v-if="isCollapse">
                <center>
                    <img v-if="isCollapse" class="img-desktop" src="@/assets/logo.png" alt="">
                    <img v-if="!isCollapse" class="img-mobile" src="@/assets/logoMobile.png" alt="">
                </center>
            </div>
            <center>
                <div class="router" :style="[{'height': height + 'vh'}, {'margin-top': margin + 'px'}]">
                    <div v-for="(item, index) in menu" :key="index" class="item">
                        <div class="item-section">
                            <router-link :to="item.to" @click.native="setSubmenuStatus(index)">
                                <div class=""><i :class="item.icon"></i><label for="" v-if="isCollapse">{{item.text}}</label></div>
                            </router-link>
                        </div>
                        <div :class="[{'block-item': item.open && isCollapse}, {'none-item': !item.open && isCollapse}, {'submenu': isCollapse}, {'submenu-mobile': !isCollapse}]" v-if="item.submenu">
                            <div v-for="(subitem, yendex) in item.submenu" :key="yendex" :class="[{'block': item.open && isCollapse}, {'none': !item.open && isCollapse}]">
                                <router-link :to="subitem.to" v-if="subitem.text === 'Estadisticas Tokens'">
                                    <div class="" @click="estadisticas()"><i :class="subitem.icon"></i><label for="">{{subitem.text}}</label></div>
                                </router-link>
                                <router-link :to="subitem.to" v-else-if="subitem.to === ''">
                                    <div class="" @click="logOut()"><i :class="subitem.icon"></i><label for="">{{subitem.text}}</label></div>
                                </router-link>
                                <router-link :to="subitem.to" v-else>
                                    <div class=""><i :class="subitem.icon"></i><label for="">{{subitem.text}}</label></div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </center>
            <div class="toogle" @click="collapse"><i class="fa-solid fa-arrows-left-right fa-2xl"></i></div>
        </div>
    </div>
</template>

<script>
import API from '@/api'

export default {
    name: 'Header',
    methods: {
        estadisticas() {
            API.getEstadisticas()
                .then((res) => {
                    window.location.href = res.link
                })
        },
        setSubmenuStatus(index) {
            this.menu[index].open = !this.menu[index].open
            if (this.menu[index].text === 'Salir') {
                this.$store.commit('logOut')
                this.$router.push('/login')
            }
        },
        collapse() {
            this.$store.state.constants.COLLAPSE = !this.isCollapse
            this.$root.$emit('collapse', !this.isCollapse)
            if (!this.isCollapse) {
                this.width = 350
                setTimeout(() => {
                    this.isCollapse = !this.isCollapse
                }, 700)
            } else {
                this.isCollapse = !this.isCollapse
            }
        }
    },
    beforeMount() {
        this.$root.$emit('getUserDetects', true)
    },
    watch: {
        isCollapse (val, oldVal) {
            if (!val) {
                this.width = 80
                this.height = 90
                this.margin = 15
            } else {
                this.height = 80
                this.margin = 0
            }
        }
    },
    data() {
        return {
            width: 350,
            isCollapse: true,
            height: 80,
            margin: 0,
            logo: require('@/assets/logo.png'),
            menu: [
                {
                    to: '/',
                    icon: 'fa-solid fa-house',
                    text: 'Inicio'
                },
                {
                    to: '',
                    icon: 'fa-solid fa-user',
                    text: 'Usuarios',
                    open: false,
                    submenu: [
                        {
                            to: '/listas',
                            icon: 'fa-solid fa-list',
                            text: 'Listas'
                        },
                        {
                            to: '/agregar-modelo',
                            icon: 'fa-solid fa-person-dress',
                            text: 'Agregar Modelo'
                        },
                        {
                            to: '/agregar-perfil-administrativo',
                            icon: 'fa-solid fa-user-plus',
                            text: 'Agregar perfil administrativo'
                        },
                        {
                            to: '/personal-administrativo',
                            icon: 'fa-solid fa-table-list',
                            text: 'Personal administrativo'
                        }
                    ]
                },
                {
                    to: '',
                    icon: 'fa-solid fa-bell',
                    text: 'Notificaciones',
                    open: false,
                    submenu: [
                        {
                            to: '/notificaciones-enviadas',
                            icon: 'fa-solid fa-paper-plane',
                            text: 'Enviadas'
                        },
                        {
                            to: '/notificaciones-pendientes',
                            icon: 'fa-solid fa-calendar',
                            text: 'Pendientes'
                        },
                        {
                            to: '/notificaciones-pausadas',
                            icon: 'fa-solid fa-pause',
                            text: 'pausadas'
                        },
                        {
                            to: '/crear-notificacion',
                            icon: 'fa-solid fa-bullhorn',
                            text: 'Crear notificacion'
                        }
                    ]
                },
                {
                    to: '',
                    icon: 'fa-solid fa-store',
                    text: 'Tienda',
                    open: false,
                    submenu: [
                        {
                            to: '/categorias',
                            icon: 'fa-solid fa-clone',
                            text: 'Categorias'
                        },
                        {
                            to: '/productos',
                            icon: 'fa-solid fa-clipboard-list',
                            text: 'Productos'
                        },
                        {
                            to: '/inventarios',
                            icon: 'fa-solid fa-boxes-stacked',
                            text: 'Inventarios'
                        }
                    ]
                },
                {
                    to: '',
                    icon: 'fa-solid fa-magnifying-glass-chart',
                    text: 'Reportes',
                    open: false,
                    submenu: [
                        {
                            to: '/plataformas',
                            icon: 'fa-solid fa-chart-bar',
                            text: 'Reporte plataformas'
                        },
                        {
                            to: '/egresos',
                            icon: 'fa-solid fa-house-chimney-crack',
                            text: 'Reporte Egresos'
                        },
                        {
                            to: '/ingresos',
                            icon: 'fa-solid fa-money-bill',
                            text: 'Reporte Ingresos'
                        },
                        {
                            to: '/consumos',
                            icon: 'fa-solid fa-comment-dollar',
                            text: 'Reporte consumos'
                        },
                        {
                            to: '/anticipos',
                            icon: 'fa-solid fa-money-check-dollar',
                            text: 'Anticipos'
                        }
                    ]
                },
                {
                    to: '/solicitudes/documentos',
                    icon: 'fa-solid fa-folder-tree',
                    text: 'Solicitudes'
                },
                {
                    to: '/perfil',
                    icon: 'fa-solid fa-user',
                    text: 'Perfil'
                },
                {
                    to: '',
                    icon: 'fa-solid fa-chart-line',
                    text: 'Estadisticas',
                    open: false,
                    submenu: [
                        {
                            to: '',
                            icon: 'fa-solid fa-comment-dollar',
                            text: 'Estadisticas Tokens'
                        },
                        {
                            to: '',
                            icon: 'fa-solid fa-money-check-dollar',
                            text: 'Estadisticas Graficas'
                        }
                    ]
                },
                {
                    to: '/palabras-claves',
                    icon: 'fa-solid fa-user-secret',
                    text: 'Palabras claves'
                },
                {
                    to: '',
                    icon: 'fa-solid fa-arrow-right-from-bracket',
                    text: 'Salir'
                }
            ]
        }
    }
}
</script>

<style>
.header {
    z-index: 999;
    background-color: #2b2926;
    position: fixed;
    height: 100vh;
    left: 0;
    transition: width 1s;
    border-right: black;
    border-style: solid;
}

.inVisible {
    visibility: hidden;
}

.menu {
    width: 100%;
}

.menu > .logo {
    width: 100%;
}

.menu > .logo > center> .img-desktop {
    padding: 20px;
    width: 200px;
}

.menu > .logo > center> .img-mobile {
    margin-bottom: 10px;
    padding: 20px;
    width: 80px;
}

.toogle {
    width: 100%;
    position: absolute;
    bottom: 0;
    color: antiquewhite;
    text-align: center;
    border: solid 2px #2b2926;
}

.toogle:hover {
    border: solid 2px;
    background-color: #fff;
    color: #2b2926;
}

.toogle > i {
    width: 100px;
    height: 50px;
}

.router {
    width: 100%;
    height: 80vh;
    overflow-y: auto;
}

.router > .item:hover > .submenu-mobile{
    display: block;
}

.router > .item > .item-section {
    position: relative;
    width: 80%;
    min-height: 70px;
    height: auto;
    border-radius: 15px;
}

.router > .item > .item-section:hover {
    color: #2b2926;
    background-color: #fff;
}

.router > .item > .item-section:hover > a {
    color: #2b2926;
}

.router > .item > .item-section > a {
    color: #fff;
    font-size: 22px;
    width: 100%;
    height: 70px;
    background-color: #2b2926;
}

.router > .item > .item-section> a > div {
    position: absolute;
    text-align: center;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
}

.router > .item > .item-section> a > div > label {
    margin-left: 20px;
}

.router > .item > .submenu{
    display: block;
    margin-bottom: 10px;
    background-color: dimgrey;
    width: 90%;
    position: relative;
    border-radius: 15px;
}

.router > .item > .submenu > div > a{
    color: #fff;
}

.router > .item > .submenu > div {
    border-radius: 20px;
}

.router > .item > .submenu > div > a{
    color: #fff;
}

.router > .item > .submenu > div:hover > a{
    color: #2b2926;
}

.router > .item > .submenu > div:hover{
    background-color: #fff;
}

.router > .item > .submenu > div > a > div > label{
    margin-left: 10px;
}

.block {
    visibility: visible;
    height: auto;
    max-height: 500px;
    transition: max-height 1s ease-in;
}

.none {
    visibility: hidden;
    max-height: 0;
    transition: max-height 1s ease-out;
}

.block-item {
    visibility: visible;
    height: auto;
    max-height: 500px;
    transition: max-height 0.3s ease-in;
    margin-top: 10px;
}

.none-item {
    max-height: 0;
    transition: max-height 0.3s ease-out;
}

.submenu-mobile {
    position: absolute;
    margin-left: 80px;
    background-color: #2b2926;
    height: auto;
    padding: 20px;
    min-width: 250px;
    border-radius: 15px;
    margin-top: -100px;
    display: none;
}

.router > .item > .submenu-mobile > div > a{
    color: #fff;
}

.router > .item > .submenu-mobile > div {
    border-radius: 20px;
}

.router > .item > .submenu-mobile > div > a{
    color: #fff;
}

.router > .item > .submenu-mobile > div:hover > a{
    color: #2b2926;
}

.router > .item > .submenu-mobile > div:hover{
    background-color: #fff;
}

.router > .item > .submenu-mobile > div > a > div > label{
    margin-left: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue